/**
 * Card box function component
 * @param {any} param0 - The param0
 * @param {any} param0.children - The children prop
 * @param {any} param0.className - The className prop
 */
function CardBox({ children, className }: { children: JSX.Element; className?: string }) {
  return (
    <div className={`card-box-warp ${className}`}>
      <div className="card-content">{children}</div>
    </div>
  );
}

CardBox.defaultProps = {
  className: '',
};

export default CardBox;
